import React from "react";
import { useNavigate } from "react-router-dom";
import { FundOutlined, GoldOutlined, SafetyCertificateOutlined, RightOutlined } from '@ant-design/icons';


function InsurePage() {
  const navigate = useNavigate();
  // Row click handlers
  const handleInvestments = () => navigate('/dashboard/insure');
  const handleMaxInvestments = () => navigate('/dashboard/pension-pension');
  const handleRetailLife = () => navigate('/dashboard/pension-life');
  return (
    <div style={{
      minHeight: '80vh',
      background: '#f5f6fa',
      padding: 16
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', paddingTop: 40, width: '100%' }}>
        <div style={{
          background: '#fff',
          borderRadius: 28,
          boxShadow: '0 8px 40px 0 rgba(0,0,0,0.10)',
          padding: '56px 64px',
          minWidth: 320,
          maxWidth: 900,
          width: '100%',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 18
        }}>
          <h2 style={{ fontWeight: 700, fontSize: 24, color: '#222', marginBottom: 0, textAlign: 'left' }}>Policies</h2>
          {/* Investments Section */}
          <div style={{ width: '100%' }}>
            <div style={{ fontWeight: 700, fontSize: 20, color: '#222', margin: '20px 0 12px 0' }}>Investments</div>
            {/* Row 1 with number above label, all aligned */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                minHeight: 70,
                borderRadius: 14,
                padding: '0 18px',
                marginBottom: 2,
                cursor: 'pointer',
                transition: 'background 0.18s',
              }}
              className="insure-row-hover"
              tabIndex={0}
              role="button"
              aria-label="Go to Old Mutual Investments"
              onClick={handleInvestments}
              onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleInvestments(); }}
            >
              <FundOutlined style={{ fontSize: 36, color: '#006400', marginRight: 24 }} />
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                <span style={{
                  color: '#888',
                  fontWeight: 500,
                  fontSize: 15,
                  letterSpacing: 1,
                  marginBottom: 2,
                  lineHeight: 1.1
                }}>3561273612693712</span>
                <span style={{ fontWeight: 500, fontSize: 21, color: '#111', lineHeight: 1.2 }}>Old Mutual Investments</span>
              </div>
              <RightOutlined style={{ fontSize: 26, color: '#bbb', marginLeft: 24 }} />
            </div>
            <div style={{ width: '100%', height: 1, background: '#eee', margin: '14px 0' }}></div>
            {/* Row 2 with number above label, all aligned */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                minHeight: 70,
                borderRadius: 14,
                padding: '0 18px',
                marginBottom: 2,
                cursor: 'pointer',
                transition: 'background 0.18s',
              }}
              className="insure-row-hover"
              tabIndex={0}
              role="button"
              aria-label="Go to Old Mutual Max Investments"
              onClick={handleMaxInvestments}
              onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleMaxInvestments(); }}
            >
              <GoldOutlined style={{ fontSize: 36, color: '#bfa100', marginRight: 24 }} />
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                <span style={{
                  color: '#888',
                  fontWeight: 500,
                  fontSize: 15,
                  letterSpacing: 1,
                  marginBottom: 2,
                  lineHeight: 1.1
                }}>3561273612693712</span>
                <span style={{ fontWeight: 500, fontSize: 21, color: '#111', lineHeight: 1.2 }}>Old Mutual Max Investments</span>
              </div>
              <RightOutlined style={{ fontSize: 26, color: '#bbb', marginLeft: 24 }} />
            </div>
          </div>
          <div style={{ width: '100%', height: 1, background: '#eee', margin: '28px 0 0 0' }}></div>
          {/* Insure Section */}
          <div style={{ width: '100%' }}>
            <div style={{ fontWeight: 700, fontSize: 20, color: '#222', margin: '20px 0 12px 0' }}>Insure</div>
            {/* Row 3 with number above label, all aligned */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                minHeight: 70,
                borderRadius: 14,
                padding: '0 18px',
                marginBottom: 2,
                cursor: 'pointer',
                transition: 'background 0.18s',
              }}
              className="insure-row-hover"
              tabIndex={0}
              role="button"
              aria-label="Go to Retail Life insurance"
              onClick={handleRetailLife}
              onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleRetailLife(); }}
            >
              <SafetyCertificateOutlined style={{ fontSize: 36, color: '#00b050', marginRight: 24 }} />
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
                <span style={{
                  color: '#888',
                  fontWeight: 500,
                  fontSize: 15,
                  letterSpacing: 1,
                  marginBottom: 2,
                  lineHeight: 1.1
                }}>3561273612693712</span>
                <span style={{ fontWeight: 500, fontSize: 21, color: '#111', lineHeight: 1.2 }}>Retail Life insurance</span>
              </div>
              <RightOutlined style={{ fontSize: 26, color: '#bbb', marginLeft: 24 }} />
            </div>
          </div>
        </div>
        <style>{`
          .insure-row-hover:hover, .insure-row-hover:focus {
            background: linear-gradient(90deg, #e6f9ed 0%, #d2f7e3 100%) !important;
          }
        `}</style>
      </div>
    </div>
  );
}

export default InsurePage;
